export default [
  {
    path: "/platformConfigurations/countries",
    component: () => import(/* webpackChunkName: "layout" */ "../layout"),

    children: [
      {
        path: ":id",
        props: true,
        name: "platform.countries.show",
        component: () => import(/* webpackChunkName: "platform.countries" */ "./show.vue"),
      },
    ],
  },
];
